import * as React from 'react';
import { Team, TradeProposalPlayer, Player, TeamPlayerInfo } from '../../../sdk/model';
import {Accordion, AccordionSummary, AccordionDetails, Typography, Paper,
  TableContainer,Table, TableHead, TableBody, TableRow, TableCell} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PlayerTradeDeadCapBalance from './PlayerTradeDeadCapBalance';

interface advancedTradeOptionsProps {
  players : TradeProposalPlayer[] | undefined,
  playerMap: Map<string | undefined, Player | undefined>,
  teamMap: Map<string | undefined, Team>,
  teamPlayerMap: Map<string | undefined, TeamPlayerInfo | undefined>,
  currentSeason: number | undefined,
  handleDeadCapChange: Function,
}

function AdvancedTradeOptions(props: advancedTradeOptionsProps) {
  return <Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="h5" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>Advanced Options</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Typography variant="h6" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>Dead Cap Balance:</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Player</TableCell>
              <TableCell>From Team</TableCell>
              <TableCell>Total Dead Cap Hit</TableCell>
              <TableCell>To Team</TableCell>
              <TableCell>Total New Cap Hit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.players?.filter(proposalPlayer => proposalPlayer.action === 'TRADE').map(proposalPlayer => 
              <PlayerTradeDeadCapBalance key={proposalPlayer.playerId} proposalPlayer={proposalPlayer} playerMap={props.playerMap} teamMap={props.teamMap} teamPlayerMap={props.teamPlayerMap} currentSeason={props.currentSeason} handleDeadCapChange={props.handleDeadCapChange} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </AccordionDetails>
  </Accordion>
}

export default AdvancedTradeOptions;
